import { forwardRef, PropsWithChildren, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import Button, { ButtonProps } from '../button/button';

type FormSubmitButtonProps = PropsWithChildren<ButtonProps> & {
  disableDirtyHandling?: boolean;
}

/**
 * Custom button which combines react-hook-form & button
 */
export const FormSubmitButton = forwardRef<HTMLButtonElement, FormSubmitButtonProps>((props, ref) => {
  const { className, children, type = 'submit', disabled, progressing, disableDirtyHandling, ref: _buttonRef, ...buttonProps } = props;

  const {
    formState: { isSubmitting, isDirty },
  } = useFormContext();

  const isButtonDisabled = useMemo(() => {
    if (disabled) return true;
    if (disableDirtyHandling) return false;
    return !isDirty;
  }, [disableDirtyHandling, disabled, isDirty])

  return (
    <Button
      className={className}
      ref={ref}
      type={type}
      disabled={isButtonDisabled}
      progressing={progressing || isSubmitting}
      {...buttonProps}
    >
      {children}
    </Button>
  );
});

export default FormSubmitButton;
